<template>
	<div class="header-container-button-container" :class="{'drop-down-list': dropDownList}" @click="buttonClick" @mouseover="mouseover" @mouseleave="mouseleave">
		<div class="icon">
			<slot></slot>
		</div>
		<div class="text">{{text}}</div>
		<div class="drop-down-button" v-if="dropDownList"></div>
		<div class="drop-down-list-shift" :class="{'drop-down-list-shift-show':showDropdownShift}" v-if="dropDownList">
			<div class="shift" v-for="(item,index) in dropDownList" :key="`shift${index}`" @click="shiftClick(item, index)">
				<div class="shift-icon" :class="item.className"></div>
				<div class="shift-text">{{item.text}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {defineComponent, reactive, toRefs} from "vue"
	
	export default defineComponent({
		name: "mainButton",
		props: {
			text: {
				type: String,
				default: ""
			},
			dropDownList: {
				type: Array,
				default: null
			}
		},
		emits:["buttonClick"],
		setup(props, {emit}){
			let data = reactive({
				showDropdownShift: false
			})
			
			let methods = {
				buttonClick() {
					if (!props.dropDownList) {
						emit("buttonClick")
					}else{
						data.showDropdownShift = !data.showDropdownShift
					}
				},
				shiftClick(item, index){
					emit("dropDownListClick",{
						item,
						index
					})
				},
				mouseover(){
					data.showDropdownShift = true
				},
				mouseleave(){
					data.showDropdownShift = false
				}
			}
			
			return {
				...toRefs(data),
				...methods
			}
		}
	})
</script>

<style lang="scss" scoped="scoped">
	@import "~@/assets/styles/_handle.scss";

	.header-container-button-container {
		height: 100%;
		width: 160px;
		display: flex;
		justify-content: center;
		align-items: center;
		align-content: center;
		cursor: pointer;
		@include font_color("home_header_button_color");
		@include font_family("font_family");

		.icon {
			height: 28px;
			width: 28px;
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}

		.text {
			height: 20px;
			width: auto;
			line-height: 20px;
			font-size: 20px;
			@include font_family("font_family");
			margin-left: 14px;
			max-width: 168px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		&.drop-down-list {
			width: auto;
			max-width: 303px;
			min-width: 170px;
			justify-content: space-between;
			padding-left: 40px;
			padding-right: 30px;
			box-sizing: border-box;
			position: relative;
		}

		.drop-down-button {
			margin-left: 12px;
			width: 12px;
			height: 8px;
			@include background_image("home_header_button_user_info_image_dropdown_button");
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}
		
		.drop-down-list-shift{
			position: absolute;
			height: auto;
			width: 100%;
			display: flex;
			flex-direction: column;
			@include background_color("home_header_button_user_info_image_dropdown_shift_bgcolor");
			z-index: -1;
			transition: all .3s;
			transform: translateY(-100%);
			opacity: 0;
			top: 60px;
			left: 0px;
			
			
			
			&.drop-down-list-shift-show{
				transition: all .3s;
				z-index: 10;
				transform: translateY(0);
				opacity: 1;
			}
			
			.shift{
				width: 100%;
				height: 56px;
				display: flex;
				align-items: center;
				align-content: center;
				padding-left: 40px;
				box-sizing: border-box;
				@include border_bottom("home_header_button_user_info_image_dropdown_shift_bottom");
				
				&:last-child{
					border-bottom: 0px solid !important;
				}
				
				.shift-icon{
					width: 24px;
					height: 24px;
					background-repeat: no-repeat;
					background-size: 100% 100%;
					
					&.shift-icon-user-center{
						@include background_image("home_header_button_user_info_image_dropdown_shift_user_center");
					}
					
					&.shift-icon-exit{
						@include background_image("home_header_button_user_info_image_dropdown_shift_exit");
					}
				}
				
				.shift-text{
					@include font_family("font_family");
					font-size: 20px;
					margin-left: 14px;
					@include font_color("home_header_button_user_info_image_dropdown_shift_font_color");
				}
			}
		}
	}
</style>
